<template>
  <v-card>
    <v-card-title>
      Privileges
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="records" :search="search" :rows-per-page-items="[20, 30, 40, 50]">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.displayName }}</td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click.native="editItem(props.item)"><v-icon>edit</v-icon></v-btn>
          <v-btn icon class="mx-0" @click.native="deleteItem(props.item)"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="warning" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      loadingState: 'noData',
      records: [],
      search: '',
      headers: [
        { text: 'Name', align: 'left', sortable: true, value: 'name' },
        { text: 'Display Name', align: 'left', sortable: true, value: 'displayName' },
        { text: 'Description', align: 'left', sortable: true, value: 'description' },
        { text: '', align: 'left', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    editItem (item) {},
    deleteItem (item) {
      this.$vuetifyConfirmDialog.open('Please Confirm', 'Are you sure you want to delete this item?', 'Cancel', 'Delete').then(state => {
        if (state) {
          this.loadingState = 'loading'
          axios.all([this.$store.dispatch('admin/deletePrivilege', item)]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              this.records.splice(this.records.indexOf(item), 1)
              this.loadingState = 'complete'
            } else {
              this.loadingState = 'error'
            }
          })).catch((err) => {
            this.loadingState = 'error'
            console.log(err)
          })
        }
      })
    },
    getData: function () {
      this.loadingState = 'loading'
      axios.all([this.$store.dispatch('admin/getPrivileges')]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload && response.data.payload.length > 0) {
            this.records = response.data.payload
            this.loadingState = 'complete'
          } else {
            this.records = []
            this.loadingState = 'noData'
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loadingState = 'error'
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loadingState = 'error'
        console.log(err)
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/PrivilegesTable.vue